export default __webpack_public_path__ + "f0599659345cf76717cdf87a98063f9f.svg";